import { ModuleApp } from '@huaca/ui';
import { TendersMark } from './TendersMark';
import { config } from './config';
import { NAV_ITEMS } from './nav';
import { AutoEnroll } from './AutoEnroll';
import { Landing } from './Landing';
import { Product } from './Product';

/** Module roles offered in org admin — mirrors huaca/src/products/tenders/roles.ts. */
const MODULE_ROLES = { tenders: ['tenders.user'] };

/**
 * The whole app.
 *
 * TWO override slots, where the other modules use none.
 *
 * `renderPlans`: calculator and claro send a first-time user to a pricing page; this product sends
 * them straight into a 3-day trial and lands them in the search screen without ever showing a plan.
 * See AutoEnroll for why it still has to branch.
 *
 * `renderLogin`: the anonymous phase is the only surface this product has before a session exists,
 * so its login screen is also its landing page — one screen, not two. `<Landing>` composes the
 * platform's own `<LoginCard>`, so the funnel keeps Google SSO, the magic link and this subdomain's
 * origin binding; the override changes what surrounds the form, never the flow around it.
 *
 * Both are PER APP, so the three other modules keep the platform defaults untouched.
 */
export function App() {
  return (
    <ModuleApp
      /* The product's own mark, so signing in does not change the brand under the user. */
      brandMark={<TendersMark size={22} />}
      productId={config.productId}
      productName={config.productName}
      moduleRoles={MODULE_ROLES}
      navItems={NAV_ITEMS}
      renderLogin={(ctx) => <Landing ctx={ctx} />}
      renderPlans={(ctx) => <AutoEnroll ctx={ctx} />}
      renderProduct={(ctx) => <Product ctx={ctx} />}
    />
  );
}
